/**
 * This is the logout controller.
 * @memberOf Logout Module
 * @namespace Logout Controller
 */

/**
 * @name logoutController
 * @desc Create the controller.
 * @param coreService
 * @memberOf Logout Module.Logout Controller
 * @ngInject
 */
function logoutController($scope, coreService, $log, $window, $sce) {

    // Assign this controller as the view-model.
    // It will be accessible as 'logoutController' within the HTML template.
    var vm = this;

    vm.onLoad = onLoad;

    // Activate the controller.
    activate();

    // Activates the controller.
    function activate() {   

        // Read Identity Server's data model
        var model = coreService.getIdentityModel();
        vm.urlsToLoad = model.iFrameUrls || [];
        vm.redirectUrl = model.redirectUrl;
        if (model.custom && model.custom.logoutMainInfo)
        {
            model.autoRedirectDelay = 2000;
            $log.debug("Custom logout message is enabled");
        }
        else
        {
            model.autoRedirectDelay = 0;
        }

        $log.debug("Redirect delay is "+ model.autoRedirectDelay+ " seconds");
        // Auto redirect
        if (model.autoRedirect && model.redirectUrl) {    
            window.setTimeout(function () {
                updateLocalStorage();
                window.location = model.redirectUrl;
            }, model.autoRedirectDelay);
        }

        $scope.model = model;
    };

    $scope.trustSrc = function(src) {          
        return $sce.trustAsResourceUrl(src);  
    }

    function onLoad(url){        
        window.setTimeout(function () {
            vm.urlsToLoad = vm.urlsToLoad.filter((item) => item !== url);
            if (!vm.urlsToLoad.length && vm.redirectUrl){
                $log.debug("About to leave the page in "+ $scope.model.autoRedirectDelay+ " seconds");
                updateLocalStorage();
                window.location = vm.redirectUrl;
            }  
        },  $scope.model.autoRedirectDelay);
    }

    function updateLocalStorage(){
      if($window.localStorage){
            var postLogOutErrorCode = localStorage.getItem('postLogOutErrorCode');
            $window.localStorage.clear();   

            if(postLogOutErrorCode)
            {
                $window.localStorage.setItem("postLogOutErrorCode", postLogOutErrorCode); //Setting value again to multi tab logout
                $window.localStorage.setItem("logOutErrorCode", postLogOutErrorCode); //Add new value to show in login page
            }
            
      }
    }
}

export default logoutController;



// WEBPACK FOOTER //
// ./src/logout/logout.controller.js